import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {
  Chart,
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  DoughnutController,
  LineController,
  CategoryScale,
  LinearScale,
  Filler,
  Legend,
  Title,
  Tooltip
} from 'chart.js';
Chart.register(
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  DoughnutController,
  LineController,
  CategoryScale,
  LinearScale,
  Filler,
  Legend,
  Title,
  Tooltip
);


/**
 * @summary ChartElement
 * @see https://www.chartjs.org/docs/latest/charts/doughnut.html
 * @extends {AoflElement}
 */
@customElement('chart-element')
class ChartElement extends AoflElement {
  /**
   * Creates an instance of ChartElement.
   */
  constructor() {
    super();
  }

  /**
   * @readonly
   */
  static is = 'chart-element';
  chart = null;
  canvas = null;
  /**
   * pie|doughnut
   */
  @property({type: String})
  type = 'pie';
  @property({type: String})
  height = '';
  @property({type: String})
  width = '';
  @property({type: String, attribute: true})
  maxHeight = 'unset';
  @property({type: Object})
  chartData = {};
  @property({type: Object})
  chartOptions = {};
  @property({type: Object})
  chartPlugins = {};
  @property({type: Array, attribute: true})
  styles = [];

  repaintChart() {
    if (this.chart !== null) {
      this.chart.destroy();
      this.chart = null;
    }
    if (this.width) {
      this.canvas.width = this.width;
    }
    if (this.height) {
      this.canvas.height = this.height;
    }

    const ctx = this.canvas.getContext('2d');
    this.chart = new Chart(ctx, {
      type: this.type,
      data: this.chartData,
      options: this.chartOptions,
      plugins: this.chartPlugins
    });
    this.dispatchEvent(new CustomEvent('chart-repaint', {
      composed: true
    }));
  }

  firstUpdated() {
    this.canvas = this.shadowRoot.querySelector('canvas');

    super.firstUpdated();
    this.repaintChart();
  }

  shouldUpdate(properties) {
    if ((properties.has('chartData') || properties.has('chartOptions')) && this.chart !== null) {
      this.repaintChart();
      return true;
    }
    if ((properties.has('height') || properties.has('width')) && this.chart !== null) {
      this.canvas.width = this.width;
      this.canvas.height = this.height;
      this.chart.resize();
      this.chart.render(true);

      // Charts that were in separate tabs were getting hidden. You must return
      // true if you want the chart to re-render. I made it conditional, only
      // for the charts that didn't have any width or height, so I wouldn't
      // overly-tax the library with rerenders.
      return (this.chart.width === 0 || this.chart.height === 0);
    }

    return true;
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles, ...this.styles]);
  }
}

export default ChartElement;
